import React from 'react';
import AccessibleModal from './AccessibleModal';
import Button from './Button';
import Icon from '../AppIcon';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Deletion',
  message = 'Are you sure you want to delete this item?',
  warningMessage = 'This action is permanent and cannot be undone.',
  itemDetails = null,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  isLoading = false
}) => {
  return (
    <AccessibleModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="small"
      closeOnOverlayClick={!isLoading}
    >
      <div className="space-y-4">
        {/* Warning Icon */}
        <div className="flex items-center justify-center w-16 h-16 mx-auto rounded-full bg-error/10">
          <Icon name="AlertTriangle" size={32} color="var(--color-error)" strokeWidth={2} />
        </div>

        {/* Message */}
        <div className="text-center space-y-2">
          <p className="text-base text-foreground font-medium">{message}</p>
          <p className="text-sm text-muted-foreground">{warningMessage}</p>
        </div>

        {/* Item Details */}
        {itemDetails && (
          <div className="bg-muted/50 rounded-lg p-4 border border-border">
            <p className="text-xs text-muted-foreground mb-2 font-medium">Item to be deleted:</p>
            <div className="space-y-1">
              {Object.entries(itemDetails)?.map(([key, value]) => (
                <div key={key} className="flex justify-between items-center">
                  <span className="text-sm text-muted-foreground capitalize">{key}:</span>
                  <span className="text-sm text-foreground font-medium">{value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-2">
          <Button
            onClick={onClose}
            variant="outline"
            fullWidth
            disabled={isLoading}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            variant="danger"
            fullWidth
            loading={isLoading}
            iconName="Trash2"
            iconPosition="left"
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </AccessibleModal>
  );
};

export default ConfirmationModal;